<div class="flex min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-6 sm:px-8">
      <div
        class="my-8 flex min-w-0 flex-auto flex-col sm:my-12 sm:flex-row sm:items-center">
        <!-- Avatar and name -->
        <div class="flex min-w-0 flex-auto items-center">
          <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img
              class="h-full w-full object-cover"
              src="images/avatars/brian-hughes.jpg" />
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            <ng-container *transloco="let t">
              <div
                class="truncate text-2xl font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug">
                {{ 'WelcomeBack' | transloco }}, {{authService.user?.Name}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Project selector -->
      <div
        class="bg-default relative flex cursor-pointer self-start overflow-hidden rounded-t-xl border border-b-0 pb-1 pl-5 pr-4 pt-2"
        matRipple>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="truncate font-medium leading-6">
              {{ 'SalesOverview' | transloco }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main -->
  <div class="-mt-px flex-auto border-t pt-4 sm:pt-6">
    <div class="mx-auto w-full max-w-screen-xl">
      <!-- Tabs -->
      <mat-tab-group
        class="sm:px-2"
        mat-stretch-tabs="false"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedTabIndex">
        <!-- Summary -->
        <mat-tab [label]="'Summary' | transloco">
          <ng-template matTabContent>
            <div
              class="grid w-full min-w-0 grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
              <!-- Summary -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow cursor-pointer">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'ReservedVehicles' | transloco}}
                  </div>
                </div>
                <div class="mt-5 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-teal-600 sm:text-8xl">
                    {{getReservedVehiclesCount}}
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow cursor-pointer">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'ContractsInProgress' | transloco}}
                  </div>
                </div>
                <div class="mt-5 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-amber-500 sm:text-8xl">
                    {{getContractsInProgressCount}}
                  </div>
                  <div
                    class="text-secondary mt-5 flex w-full items-baseline justify-center">
                    <div
                      class="truncate text-md font-medium">
                      {{'AwaitingDocs' | transloco}}:
                    </div>
                    <div
                      class="ml-1.5 text-lg font-semibold">
                      {{getContractsWithNoDocs}}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'Sold' | transloco}} {{'Vehicles' | transloco}} {{soldCarsPeriod | transloco}}
                  </div>
                  <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="featuresMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #featuresMenu="matMenu">
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('7 Days')">
                        {{'Last7Days' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('30 Days')">
                        {{'Last30Days' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('3 Months')">
                        {{'Last3Months' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('6 Months')">
                        {{'Last6Months' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('9 Months')">
                        {{'Last9Months' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('Year')">
                        {{'LastYear' | transloco}}
                      </button>
                    </mat-menu>
                  </div>
                </div>
                <div class="mt-3 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-green-500 sm:text-8xl">
                    {{getSoldCarsCount}}
                  </div>

                  <div
                    class="text-secondary mt-5 flex w-full items-baseline justify-center">
                    <div
                      class="truncate text-md font-medium">
                       {{'Delivered' | transloco}}:
                    </div>
                    <div
                      class="ml-1.5 text-lg font-semibold">
                      {{getDeliveredCarsCount}}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'PendingDeliveries' | transloco}}
                  </div>
                </div>
                <div class="mt-4 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-blue-500 sm:text-8xl">
                    {{getPendingDeliveriesCount}}
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-8 grid w-full grid-cols-1 gap-8 xl:grid-cols-2">
              <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
                <!-- Previous statement -->
                <div
                  class="bg-card relative flex flex-auto flex-col overflow-hidden rounded-2xl p-6 pb-3 pr-3 shadow">
                  <div class="absolute bottom-0 right-0 -m-6 h-24 w-24">
                    <mat-icon
                      class="text-green-500 opacity-25 icon-size-24 dark:text-green-400"
                      [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                  </div>
                  <div class="flex items-center">
                    <div class="flex flex-col">
                      <div
                        class="truncate text-lg font-medium leading-6 tracking-tight">
                        {{'CompletedContracts' | transloco}}
                      </div>
                    </div>

                  </div>
                  <div class="-mx-6 mt-4 flex flex-row flex-wrap">
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        {{'TotalSales' | transloco}} {{'Price' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalSalePriceCompleted | currency: 'CHF'
                        }}
                      </div>
                    </div>
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        {{'TotalPaid' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalCompletedPaid
                        | currency: 'CHF'
                        }}
                      </div>
                    </div>
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        Total {{'Balance' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalSalePriceCompleted - totalCompletedPaid | currency:
                        'CHF'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-card relative flex flex-auto flex-col overflow-hidden rounded-2xl p-6 pb-3 pr-3 shadow">
                  <div class="absolute bottom-0 right-0 -m-6 h-24 w-24">
                    <mat-icon
                      class="text-yellow-500 opacity-25 icon-size-24 dark:text-yellow-400"
                      [svgIcon]="'heroicons_outline:exclamation-circle'"></mat-icon>
                  </div>
                  <div class="flex items-center">
                    <div class="flex flex-col">
                      <div
                        class="truncate text-lg font-medium leading-6 tracking-tight">
                        {{'ContractsInProgress' | transloco}}
                      </div>
                    </div>
                  </div>
                  <div class="-mx-6 mt-4 flex flex-row flex-wrap">
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        {{'TotalSales' | transloco}} {{'Price' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalSalePriceInProgress
                        | currency: 'CHF'
                        }}
                      </div>
                    </div>
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        {{'TotalPaid' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalInProgressPaid
                        | currency: 'CHF'
                        }}
                      </div>
                    </div>
                    <div class="mx-6 my-3 flex flex-col">
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        Total {{'Balance' | transloco}}
                      </div>
                      <div class="mt-2 text-2xl font-medium leading-none">
                        {{
                        totalSalePriceInProgress - totalInProgressPaid
                        | currency: 'CHF'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Account balance -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow">
                <div class="flex flex-col p-6 pb-4">
                  <div class="flex items-center justify-between">
                    <div class="flex flex-col">
                      <div
                        class="mr-4 truncate text-lg font-medium leading-6 tracking-tight">
                        {{'CompletedContracts' | transloco}} {{'PerYear' | transloco}}
                      </div>
                    </div>
                    <div class="ml-2">
                      <button
                        class="bg-hover h-6 min-h-6 rounded-full px-2"
                        mat-button
                        [matMenuTriggerFor]="accountBalanceMenu">
                        <span class="text-secondary text-sm font-medium">
                          {{ setYear() }}
                        </span>
                      </button>

                      <mat-menu #accountBalanceMenu="matMenu">
                        <ng-container *ngFor="let year of availableYears">
                          <button mat-menu-item
                            (click)="setYear.set(year)">
                            {{ year }}
                          </button>
                        </ng-container>
                      </mat-menu>
                    </div>

                  </div>
                  <div class="mr-2 mt-6 flex items-start">
                    <div class="flex flex-col">
                      <div
                        class="text-3xl font-semibold tracking-tighter md:text-5xl">
                        {{getCompletedContracts}}
                      </div>
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        {{'CompletedContracts' | transloco}}
                      </div>
                    </div>
                    <div class="ml-8 flex flex-col md:ml-16">
                      <div
                        class="text-3xl font-semibold tracking-tighter md:text-5xl">
                        {{ totalSalePriceCompleted | currency: 'CHF' }}
                      </div>
                      <div
                        class="text-secondary text-sm font-medium leading-none">
                        total {{'SalePrice' | transloco}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex flex-auto flex-col">
                  <apx-chart
                    class="h-full w-full flex-auto"
                    [chart]="$any(accountBalanceOptions?.chart)"
                    [colors]="accountBalanceOptions?.colors"
                    [fill]="accountBalanceOptions?.fill"
                    [series]="accountBalanceOptions?.series"
                    [stroke]="$any(accountBalanceOptions?.stroke)"
                    [tooltip]="accountBalanceOptions?.tooltip"
                    [xaxis]="accountBalanceOptions?.xaxis"></apx-chart>
                </div>
              </div>
            </div>

            <!-- Gender -->

            <div class="mt-8 grid w-full grid-cols-1 gap-8 xl:grid-cols-3">
              <!-- Recent transactions table -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6  shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'Sales' | transloco}}
                  </div>
                  <div class="ml-2">
                    <button
                      class="bg-hover h-6 min-h-6 rounded-full px-2"
                      mat-button
                      [matMenuTriggerFor]="conversionMenu">
                      <span
                        class="text-secondary text-sm font-medium">{{salesTime | transloco}}</span>
                    </button>
                    <mat-menu #conversionMenu="matMenu">
                      <button mat-menu-item
                        (click)="salesPeriod.set('30 days')">{{'Last30Days' | transloco}}</button>
                      <button mat-menu-item
                        (click)="salesPeriod.set('3 months')">{{'Last3Months' | transloco}}</button>
                      <button mat-menu-item
                        (click)="salesPeriod.set('6 months')">{{'Last6Months' | transloco}}</button>
                      <button mat-menu-item
                        (click)="salesPeriod.set('9 months')">{{'Last9Months' | transloco}}</button>
                      <button mat-menu-item
                        (click)="salesPeriod.set('1 year')">{{'LastYear' | transloco}}</button>
                    </mat-menu>
                  </div>
                </div>
                <div class="mt-6 flex h-44 flex-auto flex-col">
                  <apx-chart
                    class="flex h-full w-full flex-auto items-center justify-center"
                    [chart]="$any(chartTopSellers()?.chart)"
                    [colors]="chartTopSellers()?.colors"
                    [labels]="chartTopSellers()?.labels"
                    [plotOptions]="$any(chartTopSellers()?.plotOptions)"
                    [series]="chartTopSellers()?.series"
                    [states]="chartTopSellers()?.states"
                    [tooltip]="chartTopSellers()?.tooltip"></apx-chart>
                </div>
                <div class="mt-8">
                  <div class="-my-3 divide-y">
                    @for (
                    dataset of data()?.topSellers;
                    track dataset;
                    let i = $index
                    ) {
                    <div class="grid grid-cols-3 py-3">
                      <div class="flex items-center">
                        <div
                          class="h-2 w-2 flex-0 rounded-full"
                          [style.backgroundColor]="
                                            chartTopSellers()?.colors[i]
                                        "></div>
                        <div class="ml-3 truncate">
                          {{ data()?.topSellers[i].sellerName }}
                        </div>
                      </div>
                      <div class="text-right font-medium">
                        <!-- {{
                        (data().gender?.uniqueVisitors * dataset) /
                        100 | number: '1.0-0'
                        }} -->
                      </div>
                      <div class="text-secondary text-right">
                        {{ dataset.amountSold | currency: 'CHF' }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2">
                <div class="p-6">
                  <div
                    class="mr-4 truncate text-lg font-medium leading-6 tracking-tight">
                    Top 5 {{'Seller' | transloco}}
                  </div>
                </div>
                <div class="mx-6 overflow-x-auto">
                  <table
                    class="w-full bg-transparent"
                    mat-table
                    matSort
                    [dataSource]="topSellersDataSource"
                    [trackBy]="trackByFn"
                    #recentTransactionsTable>

                    <!-- Name -->
                    <ng-container matColumnDef="sellerName">
                      <th
                        mat-header-cell
                        mat-sort-header
                        *matHeaderCellDef>
                        {{'Name' | transloco}}
                      </th>
                      <td mat-cell *matCellDef="let seller">
                        <span class="whitespace-nowrap pr-6">
                          {{ seller.sellerName}}
                        </span>
                      </td>
                    </ng-container>

                    <!-- amount -->
                    <ng-container matColumnDef="amount">
                      <th
                        mat-header-cell
                        mat-sort-header
                        *matHeaderCellDef>
                        {{'Sold' | transloco}}
                      </th>
                      <td mat-cell *matCellDef="let seller">
                        <span class="whitespace-nowrap pr-6">
                          {{ seller.amountSold | currency: 'CHF'}}
                        </span>
                      </td>
                    </ng-container>

                    <!-- Total -->
                    <ng-container matColumnDef="total">
                      <th
                        mat-header-cell
                        mat-sort-header
                        *matHeaderCellDef>
                        {{'ClosedContracts' | transloco}}
                      </th>
                      <td mat-cell *matCellDef="let seller">
                        <span
                          class="whitespace-nowrap pr-6 font-medium">
                          {{ seller.contractsClosed}}
                        </span>
                      </td>
                    </ng-container>

                    <!-- Footer -->
                    <ng-container matColumnDef="recentOrdersTableFooter">
                      <td
                        class="border-0 px-0 py-6"
                        mat-footer-cell
                        *matFooterCellDef
                        colspan="6">
                        <!-- <button mat-stroked-button>
                          See all transactions
                        </button> -->
                      </td>
                    </ng-container>

                    <tr
                      mat-header-row
                      *matHeaderRowDef="recentTransactionsTableColumns"></tr>
                    <tr
                      class="order-row h-16"
                      mat-row
                      *matRowDef="
                                let row;
                                columns: recentTransactionsTableColumns
                            "></tr>
                    <tr
                      class="h-16 border-0"
                      mat-footer-row
                      *matFooterRowDef="['recentOrdersTableFooter']"></tr>
                  </table>
                </div>
              </div>

            </div>

          </ng-template>
        </mat-tab>

        <!-- <mat-tab label="Delivery Calendar">
          <ng-template matTabContent>
            <app-delivery-calendar-salesperson></app-delivery-calendar-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Contracts In Progress List">
          <ng-template matTabContent>
            <app-contracts-in-progress-salesperson></app-contracts-in-progress-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Reserved Vehicles List">
          <ng-template matTabContent>
            <app-vehicles-i-reserved></app-vehicles-i-reserved>
          </ng-template>
        </mat-tab> -->

      </mat-tab-group>
    </div>
  </div>
</div>


